import React from 'react';
import Sample from './sample';
import Markdown from '@scale/frontend-lib/markdown';
import {
  IInstructionExampleSampleJson,
  IInstructionExampleJson,
} from '@scale/shared/projectInstruction/types';
import { useProjectInstructionContext } from '../projectInstructionContext';

const Example = ({ example }: { example: IInstructionExampleJson }) => {
  const { samples, description } = example;
  const { isMobileView } = useProjectInstructionContext();
  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: Markdown.render(description || ''),
        }}
      />
      <div
        style={{
          display: isMobileView ? 'unset' : 'flex',
          overflowX: 'auto',
          alignItems: 'flex-start',
        }}
      >
        {samples &&
          samples.map((sample: IInstructionExampleSampleJson, index: number) => {
            return <Sample key={index} index={index} sample={sample} />;
          })}
      </div>
    </>
  );
};

export default Example;
